import styled from "styled-components";
import {
    GrayCardWrapper
} from "../../../pages/shoppingCart/subpages/checkout/sections/reviewAndCheckout/reviewAndCheckout.style";

export const AddressCardStyle = styled(GrayCardWrapper)`
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    border-radius: 10.49px;
    font-family: Halenoir;
    padding: 15px;
    overflow: hidden;
    border: ${({$active}) => $active ? "1px solid #0B9C07" : "1px solid rgb(242, 242, 247)"};

    > :not([hidden]) ~ :not([hidden]) {
        margin-top: 0;
        margin-bottom: 0;
    }

    label {
        margin-top: 0;
        margin-bottom: 0;
    }

    > div.text {
        h4.title {
            text-align: start;
            color: var(--color-text-slight-dark);
            font-weight: 500;
            font-size: 16px;
            line-height: 100%;
            letter-spacing: 0.66px;
            text-transform: capitalize;
        }

        .card-location {
            font-weight: 400;
            font-size: 14px;
            leading-trim: NONE;
            line-height: 100%;
            letter-spacing: 0;
            text-transform: capitalize;
            color: #808080;
        }

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #0b9c07;
            padding: 6px 11px;
            font-weight: 500;
            font-size: 15px;
            leading-trim: NONE;
            line-height: 150%;
            letter-spacing: 0;
            border-radius: 5px;
            color: white;
            border: none !important;

            &:active, &:focus {
                background: #0b9c07;
            }

            svg {
                margin-right: 4px;
            }
        }
    }
    > .default-indicator {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        position: absolute;
        --bs-secondary-rgb: 240, 72, 72;
        background-color: var(--color-primary) !important;
        top: 0;
        right: 0;
        font-weight: 400;
        font-size: 12px;
        padding: 8px;
        border-radius: 0px 0px 0px 8.26px !important;

        > span {
            b {
                font-weight: 600;
            }

            margin-inline-start: 2px;
        }
    }

`